import axios from 'axios';
import { getToken as getAppCheckToken } from "firebase/app-check";
import { appCheckInstance } from '../firebase'; // Import the stored instance



// Module-level variable to store preferred language

export const fetchContent = async (query, variables) => {
  try {
    // Check if App Check was successfully initialized
    if (!appCheckInstance) {
      console.error("App Check instance is not available.");
      // Handle error: Cannot call function without App Check
      return;
    }

    let appCheckTokenResponse;
    try {
      // Pass the appCheckInstance to getToken
      appCheckTokenResponse = await getAppCheckToken(appCheckInstance /*, forceRefresh=false */);
    } catch (err) {
      console.error("Unable to get App Check token:", err);
      return;
    }

    const appCheckToken = appCheckTokenResponse.token;
    let FIREBASE_FUNCTION_URL = import.meta.env.VITE_FIREBASE_FUNCTION_FETCHCONTENT_URL;
    // variables object is expected to contain the language property
    const response = await axios.post(
      FIREBASE_FUNCTION_URL,
      { query, variables },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Firebase-AppCheck': appCheckToken,
        },
      }
    );
    
    var payload = response.data.data; 
    const regex = /#\d+"/g;
    
    if (payload) {
      let payloadString = JSON.stringify(payload);
      payloadString = payloadString.replace(regex, '"');
      payload = JSON.parse(payloadString);
    }


    // const content = response.data.data.listTopics.data[0];
    // if (!content) {
    //   throw new Error('Content not found');
    // }
    // const pictureUrl = content.pictureId ? `/images/${content.pictureId}.jpg` : null;
    // return {
    //   title: content.title,
    //   picture: pictureUrl,
    // };
    return payload;
  } catch (error) {
    console.error('Content fetch error:', error);
    throw new Error('Failed to fetch content');
  }
};


